<app-create-quick-product-lookup (productData)="close($event)"></app-create-quick-product-lookup>